<template>
  <div>
    <Loader :isLoading="getLoadingResults" />
    <div>
      <Header v-if="!viewColidee" :window="window" :parameters="'client'" />
      <div
        :class="
          !viewColidee
            ? window.width < 480
              ? 'container-fluid'
              : 'container'
            : 'pt-2'
        "
      >
        <Bandeau
          v-if="!viewColidee"
          :window="window"
          :background="background"
          :sondageName="sondageName"
        />
        <ContentResultats
          :viewColidee="viewColidee"
          :style="!viewColidee ? 'padding:5px;' : ''"
          :window="window"
          :sondageName="sondageName"
        />
      </div>
      <b-modal
        :width="640"
        :active="modalExportExcelPdf.activeModalExportExcelPdf"
      >
        <ModalExportExcelPdf :modalExportExcelPdf="modalExportExcelPdf"
      /></b-modal>
    </div>
    <br /><br />
    <MyFooter v-if="!viewColidee" :window="window" />
  </div>
</template>

<script>
import MyFooter from "@/components/layout/MyFooter";
import Header from "@/components/layout/Header";
import Loader from "@/components/layout/Loader";
import ContentResultats from "@/components/resultats/ContentResultats";
import Bandeau from "@/components/resultats/components/Bandeau";
import ModalExportExcelPdf from "@/components/sondage/components/ModalExportExcelPdf";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "ResultatsPublic",
  components: {
    Header,
    Loader,
    MyFooter,
    ContentResultats,
    Bandeau,
    ModalExportExcelPdf
  },
  data() {
    return {
      sondageName: "",
      url_moderateur: "",
      idSondage: null,
      background: "",
      window: {
        width: window.innerWidth
      },
      viewColidee: false,
      urlSondage: process.env.URL_MEDIA,
      rowIndex: 0
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleResize);
    });
  },
  watch: {
    idSondage() {
      this.getResultatsFunction();
    }
  },
  created() {
    this.$store.commit("SET_LOADING_RESULTS", true);
    var url = window.location.href;
    var string = url.substring(url.length - 9);
    var urlparticipant = string.substring(0, 6);
    axios.defaults.headers.common["urlparticipant"] = JSON.stringify({
      urlParticipant: urlparticipant,
      authorizedPreview: false,
      colideeViewResultsClient: "false"
    });
    axios
      .get(process.env.URL_SSO_API + "sondage/checkurlparticipant")
      .then(response => {
        if (
          response.data[0].id_entreprise !== null &&
          response.data[0].id_plateforme !== null
        ) {
          this.viewColidee = true;
        }
        if (response.data[0].media) {
          this.background =
            "background-size:cover;background-image:url('" +
            this.urlSondage +
            response.data[0].media +
            "')";
        } else {
          this.background =
            "background-size: cover;background-image:url(" +
            require("@/assets/img/bandeau/bandeau.jpg") +
            ")";
        }
        // if only one language and some languages in colidee + quickfix add button in colidee public results
        if (this.viewColidee) {
          var languageColidee = this.$route.params.language;
          this.$i18n.locale = languageColidee;
          if (JSON.parse(response.data[0].languages).length === 1) {
            this.$store.commit(
              "UPDATE_BUTTON_LANGUAGE_QUESTION",
              JSON.parse(response.data[0].languages)[0]
            );
          } else {
            this.$store.commit(
              "UPDATE_LANGUAGES_QUESTIONS_ADMIN",
              JSON.parse(response.data[0].languages)
            );
          }
        } else {
          var language = string.substring(string.length - 2);
          this.$i18n.locale = language;
          this.$store.commit("UPDATE_BUTTON_LANGUAGE_QUESTION", language);
        }
        this.$store.commit(
          "CONFIGURE_QUESTIONS_SONDAGE_NAME",
          response.data[0].name
        );
        this.sondageName = response.data[0].name;
        this.url_client = response.data[0].url_client;
        this.idSondage = response.data[0].id;
        this.$store.commit("CLIENT_SONDAGE_ID", response.data[0].id);
        this.$store.commit(
          "CLIENT_SONDAGE_URL_MODERATEUR",
          response.data[0].url_client
        );
        this.getResultatsFunction();
      });
  },
  methods: {
    sendMessageToParent(taskToDo) {
      let message = {
        task: taskToDo
      };
      window.top.postMessage(message, "*");
    },
    handleResize() {
      this.window.width = window.innerWidth;
    },
    getResultatsFunction() {
      this.$store
        .dispatch("getResultatsPublic", {
          token: this.url_client,
          idSondage: this.idSondage
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    ...mapGetters(["sondage_id", "getLoadingResults", "modalExportExcelPdf"]),
    reversedMessage: function() {
      return this.message
        .split("")
        .reverse()
        .join("");
    }
  },

  sockets: {
    connect() {
      if (this.idSondage !== -1) {
        var room = "Room_Sondage_" + this.idSondage;
        this.$socket.emit("room", room);
        this.$store.dispatch("getResultatsPublic", {
          token: this.url_client,
          idSondage: this.idSondage
        });
        // console.log("re-connect"), room;
      }
    },
    disconnect() {
      // console.log("disconnect");
    },

    channel(data) {
      data = JSON.parse(decodeURIComponent(data));
      if (data.type === "NEW_REPONSE") {
        this.$store.dispatch("getResultatsPublic", {
          token: this.url_client,
          idSondage: this.idSondage
        });
      }
    }
  }
};
</script>

<style scoped>
.page-content {
  position: relative;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/page/ResultatsPublic.vue